import { useEffect, useRef, useState } from 'react';

/**
 * Detecta "mobile" medindo a LARGURA DO PRÓPRIO bloco (ResizeObserver), não o
 * viewport. Isso funciona tanto no site publicado quanto no preview mobile do
 * builder (que restringe a largura do canvas em vez de mudar o viewport — onde
 * `matchMedia` não dispararia).
 *
 * Retorna um `ref` para anexar ao elemento raiz do bloco e o booleano `isMobile`.
 */
export const useContainerIsMobile = (breakpoint = 768) => {
  const ref = useRef<HTMLElement | null>(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return;

    const check = () => setIsMobile(el.getBoundingClientRect().width < breakpoint);
    check();

    const observer = new ResizeObserver(check);
    observer.observe(el);
    return () => observer.disconnect();
  }, [breakpoint]);

  return { ref, isMobile };
};
